<template>
    <div>
        <div class="content-box">
            <p style="margin-bottom:10px;padding:6px 10px;background:#f5f7fa;border-left:3px solid #409EFF;font-size:13px;">
                排单定版制作部门：<span style="color:#409EFF;">{{ schedulingGroupName || '-' }}</span>
            </p>
            <p style="color: #939393;">当输入数量超出任务剩余可指派数量时，会将该任务剩余可指派数量全部指派给该制作人</p>
            <p>最多可指派数量：{{ max_num }} <span v-if="detail[0].num > max_num" style="color:red;padding-left: 8px;">{{errMsg}}</span></p>
<!--            <p style="color:red;" v-if="detailID">任务ID：{{detailID}}存在制作人与制作时间重复的指派，继续会将两条指派合并是否继续？</p>-->
            <el-table
                size="mini"
                :data="detail"
                stripe
                border
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
            >
                <el-table-column
                    prop="size"
                    label="制作素材数"
                    align="center">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>制作素材数</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input class="ys-de-input" :value="scope.row.num" placeholder="请输入" @input="(val)=>changeNum(val,scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="material_format"
                    label="选择制作人"
                    align="center"
                    width="300">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>选择制作人</span>
                    </template>
                    <template slot-scope="scope">
<!--                        class="el-cascader-filter-name"-->
                        <JtCascader
                            popper-class="cascader-list-height-360"
                            :value="scope.row.producer_uids"
                            :options="producer_options"
                            placeholder="请选择"
                            clearable
                            filterable
                            :props="{ multiple: true, emitPath:false }"
                            @change="(val)=>changeCascader(val,scope.$index)"
                            :filter-method="filterMethod"
                            :style="{width: '100%'}"
                        ></JtCascader>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="finish_time"
                    label="制作完成日期"
                    align="center">
                    <template slot="header" slot-scope="scope">
                        <span><i style="color:red;padding-right: 3px;">*</i>制作完成日期</span>
                    </template>
                    <template slot-scope="scope">
                        <el-date-picker type="date" placeholder="选择制作完成日期"
                                        v-model="scope.row.finish_time"
                                        value-format="yyyy-MM-dd" clearable
                                        :picker-options="pickerOptions"
                                        style="width: 100%;" class="ys-de-input"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">确认</el-button>
        </p>
    </div>
</template>

<!-- 指派 批量指派-->
<script>

import {cloneDeep} from "lodash";
import {JtCascader} from "@/components/Ele";
import dayjs from "dayjs";
import {wordToPinyin} from '@/utils';

export default {
    name: "assignInfo_settleModal",
    props:['producer_options', 'multipleSelection', 'cbs', 'schedulingGroupName'],
    components:{
        JtCascader
    },
    data(){
        return {
            formLoading:false,
            errMsg:'制作素材数不可大于最多可指派数量',
            detail:[{
                num: null,
                producer_uids: null,
                finish_time: null
            }],
            detailID:'',
            rules:{

            },
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() < (Date.now()-(24 * 60 * 60 * 1000));
                },
            },
            max_num : 0
        }
    },
    mounted(){
        let maxLen = []
        this.multipleSelection.map(item=>{
            let cur_num = Number(item.material_num) - Number(item.surplusNum)
            if(cur_num > 0) {
                maxLen.push(cur_num)
            }
        })
        this.max_num = maxLen.length === 0 ? 0 : Math.max(...maxLen)
        this.detail[0].num = this.max_num === 0 ? '' : this.max_num
        const earliestDate = this.multipleSelection.map(item => dayjs(item.expected_end_time)).reduce((earliest, current) => current.isBefore(earliest) ? current : earliest);
        this.detail[0].finish_time = earliestDate.format('YYYY-MM-DD')
    },
    methods:{
        changeNum(val,index) {
            const newValue = val.replace(/[^\d]/g, '');
            if (/^[1-9]\d*$/.test(newValue)) {
                this.detail[index].num = Number(newValue);
            } else {
                this.detail[index].num = '';
            }
        },
        changeCascader(val,index) {
            this.detail[index].producer_uids = val;
            let all_name = this.modifyIdsToValues(this.producer_options, val)
            this.detail[index].producer = all_name.join(',')
        },
        filterMethod(node, keyword){
            let py = wordToPinyin(node.label);
            let allStr = py.join('');
            let capStr = py.map(item=>item[0]).join('');
            return allStr.includes(keyword)||capStr.includes(keyword)||node.text.includes(keyword);
        },
        modifyIdsToValues(arr, selectArr, resArr=[]) {
            arr.forEach(obj => {
                const newObj = { ...obj };
                if (newObj.children && newObj.children.length > 0) {
                    newObj.children = this.modifyIdsToValues(newObj.children, selectArr, resArr);
                }
                if (selectArr.includes(obj.value)) {
                    resArr.push(newObj.label)
                }
            });
            return resArr
        },
        changeDate(val,index) {
            this.detail[index].completion_date = val;

        },
        findDuplicateArrays(arr, name) {
            // let seenCombinations = new Map();
            let duplicates = [];
            arr.forEach((item, index)=>{
                let isSome =item.detail_assign.some(el=>{
                    let combination = el.finish_time + '-' + el.producer_uids.join(',');
                    let cur_number = Number(item.material_num) - Number(item.surplusNum)
                    if(combination == name && cur_number > 0) {
                        return true
                    }else{
                        return  false
                    }
                })
                if(isSome) {
                    duplicates.push({
                        index: index,
                        id: item.detail_id
                    });
                }
            })
            return duplicates;
        },
        submitModal(){
            let noNull = this.detail.some(item=>(!item.num || !item.finish_time || !item.producer_uids || item.producer_uids.length === 0 ))
            if(noNull) {
                return this.$message.error('所有项均为必填，不可为空。');
            }
            const today = dayjs().subtract(1, 'day');
            let isBeforeData = this.detail.some(item=>dayjs(item.finish_time).isBefore(today))
            if(isBeforeData) {
                return this.$message.error('制作完成日期不可早于今天');
            }

            if(this.detail[0]['num'] > this.max_num){
                return this.$message.error('制作素材数不可大于剩余可指派数量');
            }
            let combination_name = this.detail[0].finish_time + '-' + this.detail[0].producer_uids.join(',');
            const result = this.findDuplicateArrays(this.multipleSelection, combination_name)
            this.detailID = result.map(item=>item.id).join(',')
            if(this.detailID) {
                this.$confirm(`任务ID：${this.detailID }存在制作人与制作时间重复的指派，继续会将两条指派合并是否继续？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //     type: 'success',
                    //     message: '合并成功!'
                    // });
                    let cloneDeepList = this.detail.map(item=>({...item, upload_num:0}))
                    let res_detail = cloneDeep(cloneDeepList)
                    this.cbs.onSubmit(res_detail)
                }).catch(() => {

                });
            }else{
                let cloneDeepList = this.detail.map(item=>({...item, upload_num:0, lock_num: 0}))
                let res_detail = cloneDeep(cloneDeepList)
                this.cbs.onSubmit(res_detail)
            }


        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style scoped lang="scss">
.content-box{
    max-height: calc(100vh - 300px);
    overflow-y: auto;
    ::v-deep.ys-de-input.el-input--small .el-input__inner {
        height: 34px;
        line-height: 34px;
    }
}
</style>
<style lang="scss">
.el-cascader-filter-name{
    .el-cascader__tags{
        align-items: center;
        flex-wrap: nowrap;
    }
    .el-tag--info{
        &:first-child{
            span{
                display: inline-block;
                max-width: 60px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .el-cascader__search-input{
        min-width: 20px;
        font-size: 12px;
    }
}
</style>
